import { InjectionToken } from '@angular/core';
import { PwaConfig } from './interface';

export const PWA_CONFIG = new InjectionToken<PwaConfig>('PwaConfig');
